import { Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'lib-complete-check-modal',
  templateUrl: './complete-check-modal.component.html',
  styleUrls: ['./complete-check-modal.component.scss']
})
export class CompleteCheckModalComponent {

  @Output() completeEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  saveChanges() {
    console.log('save changes');
    this.completeEmit.emit(true);
  }
}
